import React, { useState, useEffect } from 'react';
import styles from './component.module.scss';
import { useForm } from "react-hook-form";
import axios from 'axios';

export function FormThursdayComponent({ onRegistered }: { onRegistered?: () => void } = {}) {

  const [manche, setManche] = useState<number | null>(null);
  const [day, setDay] = useState<number | null>(null);
  const [id, setId] = useState<number | null>(null);
  const [tournament, setTournament] = useState<string | null>(null);
  const [settings, setSettings] = useState<string | null>(null);
  const [season, setSeason] = useState<number | null>(null);
  

  useEffect(() => {
    axios.get('https://labuzifpokerclub.fr/back/api/list_set.php')
      .then((response) => {
        setManche(response.data.sp_set);
        setDay(response.data.sp_day);
        setId(response.data.sp_id);
        setTournament(response.data.sp_tournament);
        setSettings(response.data.sp_settings);
        setSeason(response.data.sp_season);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [id]);

  const [players, setPlayers] = useState<{ login: string, id: number }[]>([]);

  useEffect(() => {
    axios.get('https://labuzifpokerclub.fr/back/api/users/list.php')
      .then((response) => {
        setPlayers(response.data.list);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  const [registered, setRegistered] = useState<string[]>([]);
  const [registeredTick, setRegisteredTick] = useState(0);

  useEffect(() => {
    axios.get('https://labuzifpokerclub.fr/back/api/list_set.php?ep=listRegister')
      .then((response) => {
        setRegistered((response.data ?? []).map((u: { t_pseudo: string }) => u.t_pseudo));
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [registeredTick]);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data: any) => {
    if (registered.includes(data.pseudo)) {
      alert(data.pseudo + " est déjà inscrit à ce tournoi.");
      cancelForm();
      return;
    }
    formAction(data, manche, day, id, () => {
      setRegisteredTick((t) => t + 1);
      onRegistered?.();
    });
  };

  return (
      <div className={styles.thursday}>
        <h1 className={styles.title1}>{tournament}</h1>
        {season !== 0 ? <h1 className={styles.title1}>Saison {season} 2026</h1>: null}
        <h2 className={styles.title2}>{settings}</h2>
        <div className={styles.registrer}>
          <form className={styles.formContact} onSubmit={handleSubmit(onSubmit)}>
            <div className={styles.formItem}>
              <label htmlFor="pseudo">Pseudo <span className={styles.red}>*</span></label>
              <select id="pseudo" {...register("pseudo", { required: true })}>
                <option value="">Sélectionner un pseudo</option>
                {players.map((player) => (
                  <option key={player.id} value={player.login}>{player.login}</option>
                ))}
              </select>
            </div>
            <div className={styles.formItem}>
              <label htmlFor="password">Code <span className={styles.red}>*</span></label>
              <p><input type="password" placeholder="Code" id="password" {...register("password", { required: true })} /></p>
              {errors.lastName && <span className={styles.red}>Veuillez saisir le code !</span>}
            </div>
            <div className={styles.formItem}>
              <p className={styles.blockSubmit}>
                <input type="submit" name="sendMessage" value="Participer" id="sendMessage" className={styles.button62} />
              </p>
            </div>
          </form>
        </div>
      </div>
  );
}

async function formAction(data: { pseudo: string; password: string;}, manche: number | null, day: number | null, id: number | null, onRegistered?: () => void) {
    if (data.password !== 'poker28') {
      alert("Le code est incorrect");
      return;
    }

    axios.post('https://labuzifpokerclub.fr/api/email.php', {
      form: 'Thursday Night Poker',
      pseudo: data.pseudo,
      manche: manche,
      day: day,
      id: id
  })
    .then((response) => {
      console.log(response);
      cancelForm();
      alert("Votre inscription a bien été prise en compte " + JSON.stringify(data.pseudo) + " \n A jeudi,bonne chance !");
      onRegistered?.();
    })
    .catch(function (error) {
      cancelForm();
      console.log(error);
    });
}

function cancelForm() {
  let pseudoId = document.getElementById('pseudo') as HTMLInputElement;
  pseudoId.value = '';
  let passwordId = document.getElementById('password') as HTMLInputElement;
  passwordId.value = '';
}

function RegisterThursdayComponent(): JSX.Element {

  interface User {
      t_pseudo: string;
  }
  
    const ep = "listRegister";
    const [user, setUser] = useState<User[]>([]);
  
    useEffect(() => {
      axios.get('https://labuzifpokerclub.fr/back/api/list_set.php?ep=' + ep)
        .then((response) => {
          setUser(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    }, []);
  
    console.log(user);
  
    return (
      <div className={styles.thursdayRegister}>
        {user.map((u) => (
          <div className={styles.thursday}> {u.t_pseudo} </div>
        ))}
        </div>
    );
  }

// import React, { useState, useEffect } from 'react';
// import styles from './component.module.scss';
// import { useForm } from "react-hook-form";
// import axios from 'axios';

// interface Player {
//   login: string;
//   id: number;
// }

// interface RegisteredPlayer {
//   t_pseudo: string;
// }

// export function FormThursdayComponent() {

//   const [manche, setManche] = useState<number | null>(null);
//   const [day, setDay] = useState<number | null>(null);
//   const [id, setId] = useState<number | null>(null);
//   const [tournament, setTournament] = useState<string | null>(null);
//   const [settings, setSettings] = useState<string | null>(null);
//   const [season, setSeason] = useState<number | null>(null);

//   const [players, setPlayers] = useState<Player[]>([]);
//   const [registeredPlayers, setRegisteredPlayers] = useState<RegisteredPlayer[]>([]);
//   const [loading, setLoading] = useState(false);
//   const [success, setSuccess] = useState<string | null>(null);

//   const { register, handleSubmit, reset, watch, formState: { errors } } = useForm();

//   const selectedPseudo = watch("pseudo");

//   // 🔹 Infos tournoi
//   useEffect(() => {
//     axios.get('https://labuzifpokerclub.fr/back/api/list_set.php')
//       .then((res) => {
//         setManche(res.data.sp_set);
//         setDay(res.data.sp_day);
//         setId(res.data.sp_id);
//         setTournament(res.data.sp_tournament);
//         setSettings(res.data.sp_settings);
//         setSeason(res.data.sp_season);
//       })
//       .catch(console.log);
//   }, []);

//   // 🔹 Joueurs
//   useEffect(() => {
//     axios.get('https://labuzifpokerclub.fr/back/api/users/list.php')
//       .then((res) => setPlayers(res.data.list))
//       .catch(console.log);
//   }, []);

//   // 🔹 Fetch inscrits
//   const fetchRegisteredPlayers = () => {
//     axios.get('https://labuzifpokerclub.fr/back/api/list_set.php?ep=listRegister')
//       .then((res) => setRegisteredPlayers(res.data))
//       .catch(console.log);
//   };

//   // 🔹 Initial + auto refresh
//   useEffect(() => {
//     fetchRegisteredPlayers();

//     const interval = setInterval(fetchRegisteredPlayers, 5000);
//     return () => clearInterval(interval);
//   }, []);

//   // 🔹 Vérifie si déjà inscrit
//   const isAlreadyRegistered = (pseudo: string) => {
//     return registeredPlayers.some(p => p.t_pseudo === pseudo);
//   };

//   // 🔹 Submit
//   const onSubmit = async (data: any) => {

//     if (data.password !== 'poker28') {
//       setSuccess("❌ Code incorrect");
//       return;
//     }

//     if (isAlreadyRegistered(data.pseudo)) {
//       setSuccess("⚠️ Déjà inscrit !");
//       return;
//     }

//     setLoading(true);
//     setSuccess(null);

//     // ⚡ Optimistic update
//     setRegisteredPlayers(prev => [...prev, { t_pseudo: data.pseudo }]);

//     try {
//       await axios.post('https://labuzifpokerclub.fr/api/email.php', {
//         form: 'Thursday Night Poker',
//         pseudo: data.pseudo,
//         manche,
//         day,
//         id
//       });

//       setSuccess(`✅ ${data.pseudo} est inscrit !`);
//       reset();

//       // refresh réel
//       fetchRegisteredPlayers();

//     } catch (error) {
//       console.log(error);
//       setSuccess("❌ Erreur serveur");

//       // rollback si erreur
//       fetchRegisteredPlayers();
//     }

//     setLoading(false);

//     // 🔥 auto hide message
//     setTimeout(() => setSuccess(null), 4000);
//   };

//   return (
//     <div className={styles.thursday}>

//       <h1 className={styles.title1}>{tournament}</h1>
//       {season !== 0 && <h1 className={styles.title1}>Saison {season} 2026</h1>}
//       <h2 className={styles.title2}>{settings}</h2>

//       {/* MESSAGE */}
//       {success && (
//         <div className={styles.successMessage}>
//           {success}
//         </div>
//       )}

//       {/* FORM */}
//       <div className={styles.registrer}>
//         <form className={styles.formContact} onSubmit={handleSubmit(onSubmit)}>

//           <div className={styles.formItem}>
//             <label>Pseudo *</label>
//             <select {...register("pseudo", { required: true })}>
//               <option value="">Sélectionner</option>
//               {players.map((p) => (
//                 <option key={p.id} value={p.login}>
//                   {p.login}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className={styles.formItem}>
//             <label>Code *</label>
//             <input
//               type="password"
//               {...register("password", { required: true })}
//             />
//             {errors.password && <span className={styles.red}>Requis</span>}
//           </div>

//           <input
//             type="submit"
//             value={loading ? "Inscription..." : "Participer"}
//             disabled={loading || isAlreadyRegistered(selectedPseudo)}
//             className={styles.button62}
//           />

//         </form>
//       </div>

//       {/* LISTE */}
//       <div className={styles.thursdayRegister}>
//         <h3>Joueurs inscrits ({registeredPlayers.length})</h3>

//         {registeredPlayers.map((p, i) => (
//           <div key={i} className={styles.player}>
//             🟢 {p.t_pseudo}
//           </div>
//         ))}
//       </div>

//     </div>
//   );
// }